import { useTranslation } from 'react-i18next';

import { DatePickerField } from 'fields';
import { useField } from 'formik';
import dayjs from 'dayjs';

export default function DeliveryEndDate() {
  const { t } = useTranslation('CreateOrder');
  const [{ value: startDate }] = useField('startDate');
  const [{ value: transportMethod }] = useField('transportMethod');

  return (
    <DatePickerField
      required
      disablePast
      name="endDate"
      minDate={dayjs(startDate).isValid() ? dayjs(startDate) : undefined}
      label={t(`ProductForm.labels.endDate${transportMethod}`)}
    />
  );
}
